import { GET_SEARCH_FILTER_STRUCTURE, DOMAIN_NAME } from '@/constants';
import { SearchFilterStructureRo } from '@/types';
import { getAcceptLanguageHeader, type Locale } from '@/config/i18n/locales';
import { withServerTiming } from '@/lib/serverTiming';
import { logSsrFetch } from '@/lib/ssrLog';

export const fetchSearchFiltersSsr = async (
  locale?: Locale,
): Promise<SearchFilterStructureRo | null> =>
  withServerTiming('fetchSearchFiltersSsr', async () => {
    try {
      const headers: Record<string, string> = {};
      if (locale) headers['Accept-Language'] = getAcceptLanguageHeader(locale);

      const url = `${process.env.NEXT_PUBLIC_API_URL}${GET_SEARCH_FILTER_STRUCTURE}/${DOMAIN_NAME}`;
      const start = performance.now();
      const res = await fetch(url, { cache: 'no-store', headers });
      logSsrFetch({ url, timing: performance.now() - start, status: res.status });

      if (!res.ok) return null;

      return (await res.json()) as SearchFilterStructureRo;
    } catch (err) {
      console.error('fetchSearchFiltersSsr ERROR:', err);
      return null;
    }
  });
